import PropTypes from 'prop-types';

export const SchoolAttendanceProps = PropTypes.shape({
  id: PropTypes.number,
  date_time: PropTypes.string,
  start_time: PropTypes.string,
  end_time: PropTypes.string,
  deadline_time: PropTypes.number,
  pre_absence: PropTypes.bool,
  cancel_status: PropTypes.string,
  attended: PropTypes.bool,
  reason: PropTypes.string,
  comment: PropTypes.string,
  tooltip: PropTypes.bool,
  progress_comment: PropTypes.string,
  progress_comment_ready: PropTypes.bool,
  reminder_send: PropTypes.bool,
});

export const passedDeadLIne = (x) => {
  return new Date(x.deadline_time) < Date.now();
};

export const passedEndTime = (x) => {
  return new Date(x.end_time) < Date.now();
};

export const getStatusString = (x) => {
  if (x.cancel_status === 'canceled') {
    return 'キャンセル済';
  }
  if (x.cancel_status === 'unsubscribed') {
    if (passedEndTime(x)) {
      return '退塾済';
    }
    return '退塾予定';
  }
  if (!passedEndTime(x)) {
    if (x.pre_absence) {
      return '事前欠席';
    }
    if (!x.pre_absence) {
      return '出席予定';
    }
  }
  if (x.attended === true) {
    return '出席済';
  }
  if (x.pre_absence === 'pre_absence') {
    return '事前欠席';
  }
  return '当日欠席';
};

export const getStatusColor = (x) => {
  switch (getStatusString(x)) {
    case '出席予定':
      return 'green';
    case '事前欠席':
      return 'pink';
    case '当日事前欠席':
      // TODO: css
      return 'pink';
    default:
      return 'grey';
  }
};

export const enableReminderButton = (commited, attendance) => {
  return attendance.reminder_send || (!commited && (
    getStatusString(attendance) === '出席予定' && !attendance.attended)
  );
};

export default SchoolAttendanceProps;
